import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `CellDirective` represent a cell of the React Spreadsheet.
 * It must be contained in a `RowDirective`.
 * ```tsx
 * <SpreadsheetComponent>
 *   <SheetsDirective>
 *    <SheetDirective>
 *    <RowsDirective>
 *    <RowDirective>
 *    <CellsDirective>
 *    <CellDirective value='A1'></CellDirective>
 *    </CellsDirective>
 *    </RowDirective>
 *    </RowsDirective>
 *    </SheetDirective>
 *   </SheetsDirective>
 * </SpreadsheetComponent>
 * ```
 */
export class CellDirective extends ComplexBase {
}
CellDirective.moduleName = 'cell';
export class CellsDirective extends ComplexBase {
}
CellsDirective.propertyName = 'cells';
CellsDirective.moduleName = 'cells';
